// extracted by mini-css-extract-plugin
export default {"main":"styles_main__wN9pE","heading":"styles_heading__nHByT","subheading":"styles_subheading__DW57E"};